/* ============================================================
   jueves-picante-progress.js — Barra de progreso de JUEVES DE SERENÉ PICANTE.
   1) Detecta cambios del carrito SIN tocar el JS del tema: observa (solo
      lectura, PerformanceObserver) las peticiones a /cart/add|change|update|clear
      hechas por cualquier script y vuelve a leer /cart.js. Cuenta solo
      productos de la colección (data-ids).
   2) Botón «+» de las tarjetas (solo en esta página): se atiende aquí en fase
      de captura, antes que minimal-coleccion.js (que NO se modifica). Agrega
      igual que siempre (burbuja + drawer actualizados, check ✓) pero el
      cart-drawer solo se abre al llegar a 6+ fragancias de la colección.
   3) Botón «Ver mi carrito» de la barra: abre el cart-drawer.
   ============================================================ */
(function () {
  var el = document.querySelector('[data-jp-progress]');
  if (!el || el.__jpInit) return;
  el.__jpInit = true;

  var OPEN_AT = 6;
  var ids = el.getAttribute('data-ids') || ',';
  var msgEl = el.querySelector('[data-jp-msg]');
  var countEl = el.querySelector('[data-jp-count]');
  var saveEl = el.querySelector('[data-jp-save]');
  var cartBtn = el.querySelector('[data-jp-cart]');
  var steps = el.querySelector('[role="progressbar"]');
  var current = parseInt(countEl ? countEl.textContent : '0', 10) || 0;

  function tpl(i) {
    var t = el.querySelector('template[data-jp-tpl="' + i + '"]');
    return t ? t.innerHTML.trim() : '';
  }
  function saveTxt(i) {
    var t = el.querySelector('template[data-jp-tpl="' + i + '"]');
    return t ? (t.getAttribute('data-save') || '').trim() : '';
  }

  function setCartBtn(total) {
    if (!cartBtn) return;
    var show = total > 0;
    if (cartBtn.hidden === !show) return;
    cartBtn.hidden = !show;
  }

  function render(n, total) {
    if (typeof total === 'number') setCartBtn(total);
    var shown = Math.min(n, 6);
    if (shown === current) return;
    var up = shown > current;
    current = shown;
    if (msgEl) msgEl.innerHTML = tpl(shown);
    if (saveEl) {
      var sv = saveTxt(shown);
      saveEl.textContent = sv;
      saveEl.hidden = !sv;
    }
    if (countEl) countEl.textContent = shown;
    if (steps) steps.setAttribute('aria-valuenow', shown);
    el.querySelectorAll('.jp-progress__step').forEach(function (li, idx) {
      li.classList.toggle('is-on', idx < shown);
    });
    el.classList.toggle('is-complete', shown >= 6);
    if (up) {
      el.classList.remove('is-bump');
      void el.offsetWidth;
      el.classList.add('is-bump');
    }
  }

  function countOf(cart) {
    var n = 0;
    (cart.items || []).forEach(function (it) {
      if (ids.indexOf(',' + it.product_id + ',') !== -1) n += it.quantity;
    });
    return n;
  }
  function getCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(r); });
  }

  var busy = false, again = false;
  function refresh() {
    if (busy) { again = true; return; }
    busy = true;
    getCart()
      .then(function (cart) { render(countOf(cart), cart.item_count || 0); })
      .catch(function () {})
      .then(function () {
        busy = false;
        if (again) { again = false; refresh(); }
      });
  }

  var timer;
  function schedule() { clearTimeout(timer); timer = setTimeout(refresh, 120); }

  var CART_RE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  if ('PerformanceObserver' in window) {
    try {
      new PerformanceObserver(function (list) {
        list.getEntries().forEach(function (e) {
          try { if (CART_RE.test(new URL(e.name, location.href).pathname)) schedule(); } catch (err) {}
        });
      }).observe({ type: 'resource', buffered: false });
    } catch (err) {}
  }

  /* Respaldo: el cart-drawer del tema se re-renderiza en cada cambio del
     carrito (quitar, cantidades, vaciar). Solo se observa, no se modifica. */
  var drawer = document.querySelector('cart-drawer');
  if (drawer && 'MutationObserver' in window) {
    /* El drawer tiene timers que mutan el DOM seguido: solo reaccionar si
       cambian los productos o cantidades (firma). */
    var sig = function () {
      var s = '';
      drawer.querySelectorAll('.cart-item').forEach(function (li) {
        var q = li.querySelector('input.quantity__input, input[name="updates[]"]');
        s += li.className + ':' + (q ? q.value : '') + '|';
      });
      return s;
    };
    var lastSig = sig();
    new MutationObserver(function () {
      var now = sig();
      if (now !== lastSig) { lastSig = now; schedule(); }
    }).observe(drawer, { childList: true, subtree: true });
  }

  /* ---------- Cart drawer: abrir / refrescar (mismo patrón que minimal-coleccion.js) ---------- */
  function openDrawer(trigger) {
    var d = document.querySelector('cart-drawer');
    if (d && typeof d.open === 'function') { d.open(trigger); return; }
    window.location.href = (window.routes && window.routes.cart_url) || '/cart';
  }
  function refreshBubble(sections) {
    try {
      if (sections && sections['cart-icon-bubble']) {
        var p = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
        var t = document.getElementById('cart-icon-bubble');
        var s = p.querySelector('#shopify-section-cart-icon-bubble') || p.querySelector('.shopify-section');
        if (t && s) t.innerHTML = s.innerHTML;
      }
    } catch (e) {}
  }
  function updateDrawer(sections) {
    try {
      if (sections && sections['cart-drawer']) {
        var p = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
        var t = document.querySelector('cart-drawer');
        var s = p.querySelector('cart-drawer');
        if (t && s) {
          t.classList.toggle('is-empty', s.classList.contains('is-empty'));
          t.innerHTML = s.innerHTML;
        }
      }
    } catch (e) {}
  }

  /* ---------- 2. Botón «+» de esta colección (captura → antes que minimal-coleccion.js) ---------- */
  var root = el.closest('[data-mc-root]');
  if (root) {
    root.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('[data-mc-add]') : null;
      if (!btn || !root.contains(btn)) return;
      e.preventDefault();
      e.stopPropagation();
      if (btn.classList.contains('is-loading') || btn.hasAttribute('disabled')) return;
      var id = btn.getAttribute('data-variant-id');
      if (!id) return;

      btn.classList.add('is-loading');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          id: id, quantity: 1,
          sections: 'cart-icon-bubble,cart-drawer',
          sections_url: window.location.pathname
        })
      })
        .then(function (r) { return r.ok ? r.json() : Promise.reject(r); })
        .then(function (data) {
          btn.classList.remove('is-loading');
          btn.classList.add('is-added');
          setTimeout(function () { btn.classList.remove('is-added'); }, 2000);
          refreshBubble(data.sections);
          updateDrawer(data.sections);
          return getCart().then(function (cart) {
            var n = countOf(cart);
            render(n, cart.item_count || 0);
            if (n >= OPEN_AT) openDrawer(btn);
            else if (cartBtn) {
              cartBtn.classList.remove('is-nudge');
              void cartBtn.offsetWidth;
              cartBtn.classList.add('is-nudge');
            }
          });
        })
        .catch(function () { btn.classList.remove('is-loading'); });
    }, true);
  }

  /* ---------- 3. «Ver mi carrito» ---------- */
  if (cartBtn) {
    cartBtn.addEventListener('animationend', function () { cartBtn.classList.remove('is-nudge'); });
    cartBtn.addEventListener('click', function (e) {
      e.preventDefault();
      openDrawer(cartBtn);
    });
  }

  /* Altura real de la barra → espacio reservado al final de la página */
  function setH() { document.documentElement.style.setProperty('--jp-progress-h', el.offsetHeight + 'px'); }
  setH();
  if ('ResizeObserver' in window) new ResizeObserver(setH).observe(el);

  /* Volver con atrás (bfcache) o regresar a la pestaña: re-sincroniza */
  window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });
  document.addEventListener('visibilitychange', function () { if (!document.hidden) schedule(); });
})();
